module.exports = "\r\n<div class=\"fixed-bottom\" id =\"footer\">\r\n  \r\n    Cat WorldBG 2018\r\n  \r\n</div>\r\n"